document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".header__localization .disclosure").forEach(disclosure => {
    const wrapper = disclosure.querySelector(".disclosure__list-wrapper");
    if (!wrapper) return;

    disclosure.addEventListener("toggle", () => {
      if (disclosure.open) wrapper.removeAttribute("hidden");
      else wrapper.setAttribute("hidden", "");
    });

    wrapper.querySelectorAll(".disclosure__link").forEach(link => {
      link.addEventListener("click", e => {
        e.preventDefault();
        const form = disclosure.closest("form");
        const input = form?.querySelector("input[name*='locale'], input[name*='country']");
        if (!input) return;
        input.value = link.dataset.value;
        form.submit();
      });
    });
  });
});
